import api from '@/js/services/api';
export default {
    getFaqInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/settings/faqs/get?' + searchParams.toString())
    },


    deleteFaqItem(id) {
        return api().delete(`/master-admin/settings/faqs/${id}/delete`);
    },

    saveNewItem(form) {
        return api().post(`/master-admin/settings/faqs/create`, form)
    },

    updateItem(id, faq) {
        return api().put(`/master-admin/settings/faqs/${id}/update`, faq )
    },

    //for employee

    getListOfFaqs() {
        return api().get(`/applicant/faqs/get`)
    },

}
